import {ViewMode} from '../../constants/dataEnum';
import {ReteachPlate} from '../../constants/actionType';

const initialState = {
  reteachPlates: [],
  manualReteachPlate: {
    isMoveMotionControl: false,
    deckNumber: 5,
    currentPosition: {},
    currentInfo: {},
    selectedWellStyle: {},
    returnToCaddy: false,
  },
  lastViewMode: ViewMode.EXPLORER,
};

export default function reteachPlateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ReteachPlate.SET_RETEACH_PLATES:
      return {
        ...state,
        reteachPlates: [...action.reteachPlates],
      };
    case ReteachPlate.SET_MANUAL_RETEACH_CURRENT_POSITION:
      return {
        ...state,
        manualReteachPlate: {
          ...state.manualReteachPlate,
          currentPosition: action.currentPosition,
        },
      };
    case ReteachPlate.SET_MANUAL_RETEACH_CURRENT_INFO:
      return {
        ...state,
        manualReteachPlate: {
          ...state.manualReteachPlate,
          currentInfo: action.currentInfo,
        },
      };
    case ReteachPlate.SET_MOVE_MOTION_CONTROL:
      return {
        ...state,
        manualReteachPlate: {
          ...state.manualReteachPlate,
          isMoveMotionControl: true,
        },
      };
    case ReteachPlate.SET_SELECTED_WELL_STYLE:
      return {
        ...state,
        manualReteachPlate: {
          ...state.manualReteachPlate,
          selectedWellStyle: action.selectedWellStyle,
        },
      };
    case ReteachPlate.SET_RETURN_TO_CADDY:
      return {
        ...state,
        manualReteachPlate: {
          ...state.manualReteachPlate,
          returnToCaddy: action.returnToCaddy,
        },
      };
    case ReteachPlate.SET_LAST_VIEW_MODE:
      return {
        ...state,
        lastViewMode: action.lastViewMode,
      };
    case ReteachPlate.RESET_MANUAL_RETEACH_PLATE:
      return {
        ...state,
        manualReteachPlate: {
          ...state.manualReteachPlate,
          isMoveMotionControl: false,
          currentPosition: {},
          currentInfo: {},
          returnToCaddy: false,
        },
      };
    case ReteachPlate.RESET_RETEACH_PLATE:
      return initialState;
    case ReteachPlate.REMOVE_UPDATED_PLATE:
      return {
        ...state,
        reteachPlates: state.reteachPlates.filter((plate) => plate.id !== action.plateId),
      };
    case ReteachPlate.RESTORE_STATE:
      return action.state;
    default:
      return state;
  }
}
